const food = [
  {
    "web-scraper-order": "1666024507-692",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫙 Jar",
    "food-href": "https://emojipedia.org/jar/",
    emoji: "🫙",
    emojiName: "🫙 Jar",
    description: "An empty glass jar.",
  },
  {
    "web-scraper-order": "1666024510-693",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥄 Spoon",
    "food-href": "https://emojipedia.org/spoon/",
    emoji: "🥄",
    emojiName: "🥄 Spoon",
    description:
      "A silver spoon, as used to eat soup, cereal, or ice cream as well as serve food or stir drinks. Positioned at various angles across platforms. May be paired with Fork and Knife, Fork and Knife With Plate, and Bowl With Spoon.",
  },
  {
    "web-scraper-order": "1666024512-694",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍴 Fork and Knife",
    "food-href": "https://emojipedia.org/fork-and-knife/",
    emoji: "🍴",
    emojiName: "🍴 Fork and Knife",
    description:
      "A silver fork to the left of a knife, silverware or cutlery used to eat a meal. Often used more generally for eating and dining. May be paired with Spoon or used with Fork and Knife With Plate.",
  },
  {
    "web-scraper-order": "1666024514-695",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍽️ Fork and Knife with Plate",
    "food-href": "https://emojipedia.org/fork-and-knife-with-plate/",
    emoji: "🍽️",
    emojiName: "🍽️ Fork and Knife with Plate",
    description:
      "A silver fork and knife on either side of a white plate, as set for dinner or another meal. Often used more generally for eating and dining. May be paired with Spoon.",
  },
  {
    "web-scraper-order": "1666024517-696",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥢 Chopsticks",
    "food-href": "https://emojipedia.org/chopsticks/",
    emoji: "🥢",
    emojiName: "🥢 Chopsticks",
    description:
      "A pair of equal-length chopsticks, an eating utensil used throughout East Asia. Design and color vary widely by platform, though often red or wood-colored and with tips angled together. Featured in many platforms' Steaming Bowl of Food and Takeout Box. A counterpart to utensils such as Fork and Knife and Spoon.",
  },
  {
    "web-scraper-order": "1666024519-697",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧊 Ice",
    "food-href": "https://emojipedia.org/ice/",
    emoji: "🧊",
    emojiName: "🧊 Ice",
    description:
      "A blue cube of ice. Can be used to talk about ice or cold temperatures in general. This emoji can also be used metaphorically to talk about something that is cool or chill.",
  },
  {
    "web-scraper-order": "1666024521-698",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧉 Mate",
    "food-href": "https://emojipedia.org/mate/",
    emoji: "🧉",
    emojiName: "🧉 Mate",
    description:
      "Mate is a caffeinated beverage popular in many South American countries. Green in color (from a key ingredient: the dried leaves of yerba mate) and consumed via a metal straw.",
  },
  {
    "web-scraper-order": "1666024524-699",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧃 Beverage Box",
    "food-href": "https://emojipedia.org/beverage-box/",
    emoji: "🧃",
    emojiName: "🧃 Beverage Box",
    description:
      "Originally proposed as Juice, this emoji can be used to talk about juice or other liquids that come in boxes with straws. It can also be used metaphorically to talk about power, energy, respect, or an elusive quality that makes someone special.",
  },
  {
    "web-scraper-order": "1666024526-700",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧋 Bubble Tea",
    "food-href": "https://emojipedia.org/bubble-tea/",
    emoji: "🧋",
    emojiName: "🧋 Bubble Tea",
    description:
      "Bubble tea is a tea-based drink invented in Taiwan which typically contain tea, flavored milk, and sugar. Commonly served with tapioca pearls, also known as boba, in a plastic cup with a wide straw.",
  },
  {
    "web-scraper-order": "1666024528-701",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥤 Cup with Straw",
    "food-href": "https://emojipedia.org/cup-with-straw/",
    emoji: "🥤",
    emojiName: "🥤 Cup with Straw",
    description:
      "A drinking cup with a straw. Depicted on many platforms as a disposable cup with a lid and bendy straw, as used to serve soft drinks at fast-food restaurants. May be used for a range of non-alcoholic beverages, including milkshakes, smoothies, juice, and to-go beverages.",
  },
  {
    "web-scraper-order": "1666024531-702",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫗 Pouring Liquid",
    "food-href": "https://emojipedia.org/pouring-liquid/",
    emoji: "🫗",
    emojiName: "🫗 Pouring Liquid",
    description: "A glass pouring liquid.",
  },
  {
    "web-scraper-order": "1666024536-703",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥃 Tumbler Glass",
    "food-href": "https://emojipedia.org/tumbler-glass/",
    emoji: "🥃",
    emojiName: "🥃 Tumbler Glass",
    description:
      "A short, flat glass, as used for brown liquors like whiskey or Scotch whisky.",
  },
  {
    "web-scraper-order": "1666024539-704",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥂 Clinking Glasses",
    "food-href": "https://emojipedia.org/clinking-glasses/",
    emoji: "🥂",
    emojiName: "🥂 Clinking Glasses",
    description:
      "Two flutes of champagne or sparkling wine being clinked together, as done at a celebratory or convivial toast (“Cheers!”). Samsung’s design suggests two glasses of white wine. Some platforms include stylized links to mark the clinking. See also Clinking Beer Mugs—and Bottle With Popping Cork for a refill.",
  },
  {
    "web-scraper-order": "1666024547-705",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍻 Clinking Beer Mugs",
    "food-href": "https://emojipedia.org/clinking-beer-mugs/",
    emoji: "🍻",
    emojiName: "🍻 Clinking Beer Mugs",
    description:
      "Two frosty mugs of beer with frothy heads being clinked together, as done at a celebratory or convivial toast (“Cheers!”). Several platforms include stylized lines to mark the clinking. See also 🥂 Clinking Glasses.",
  },
  {
    "web-scraper-order": "1666024551-706",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍺 Beer Mug",
    "food-href": "https://emojipedia.org/beer-mug/",
    emoji: "🍺",
    emojiName: "🍺 Beer Mug",
    description:
      "A beer, as a golden-colored lager, in a frosty mug. Depicted with a frothy head spilling over the brim. 🍻 Clinking Beer Mugs is a variation that displays two such beer mugs.",
  },
  {
    "web-scraper-order": "1666024555-707",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍹 Tropical Drink",
    "food-href": "https://emojipedia.org/tropical-drink/",
    emoji: "🍹",
    emojiName: "🍹 Tropical Drink",
    description:
      "A sunset-orange-colored tropical beverage in a stemmed glass, as a rum punch or mai tai. Served with a straw and fruit garnish. Many platforms include a cocktail umbrella, hence umbrella drink. Samsung previously featured an electric-blue concoction. See also Cocktail Glass.",
  },
  {
    "web-scraper-order": "1666024557-708",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍸 Cocktail Glass",
    "food-href": "https://emojipedia.org/cocktail-glass/",
    emoji: "🍸",
    emojiName: "🍸 Cocktail Glass",
    description:
      "A stemmed glass with a cone-shaped bowl, used for serving cocktails. Depicted as a martini garnished with an olive. Might be gin or vodka, shaken or stirred. See also Tropical Drink.",
  },
  {
    "web-scraper-order": "1666024560-709",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍷 Wine Glass",
    "food-href": "https://emojipedia.org/wine-glass/",
    emoji: "🍷",
    emojiName: "🍷 Wine Glass",
    description:
      "Red wine served in a stemmed glass. Google previously displayed an orange-colored drink that resembled cognac.",
  },
  {
    "web-scraper-order": "1666024564-710",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍾 Bottle with Popping Cork",
    "food-href": "https://emojipedia.org/bottle-with-popping-cork/",
    emoji: "🍾",
    emojiName: "🍾 Bottle with Popping Cork",
    description:
      "A green bottle of champagne or sparkling wine with label, its cork popping to shoot out its bubbly contents. Used for a range of celebratory occasions, such as New Year's Eve, birthdays, weddings, or other life accomplishments.",
  },
  {
    "web-scraper-order": "1666024567-711",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍶 Sake",
    "food-href": "https://emojipedia.org/sake/",
    emoji: "🍶",
    emojiName: "🍶 Sake",
    description:
      "Japanese sake, an alcoholic beverage made from rice. Shown as a sake set with a carafe (tokkuri) and drinking cup (choko). Most platforms show a cream colored sake set with a blue or red stripe motif. Samsung's design used to show the Japanese script for 'sake' in red along the side of the carafe.",
  },
  {
    "web-scraper-order": "1666024569-712",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍵 Teacup Without Handle",
    "food-href": "https://emojipedia.org/teacup-without-handle/",
    emoji: "🍵",
    emojiName: "🍵 Teacup Without Handle",
    description:
      "A cup of green tea, as the minty-colored Japanese matcha, usually shown on a wooden mat. Matcha is traditionally served in a small bowl that resembles a cup without a handle. Often taken as a bowl of soup, such as a split pea.",
  },
  {
    "web-scraper-order": "1666024572-713",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫖 Teapot",
    "food-href": "https://emojipedia.org/teapot/",
    emoji: "🫖",
    emojiName: "🫖 Teapot",
    description:
      "A classic teapot with a wide bulbous body, a spout, a handle, and a lid. Can be used to talk about tea, tea time, or warm beverages in general.",
  },
  {
    "web-scraper-order": "1666024576-714",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "☕ Hot Beverage",
    "food-href": "https://emojipedia.org/hot-beverage/",
    emoji: "☕",
    emojiName: "☕ Hot Beverage",
    description:
      "A cup of a steaming-hot beverage, usually taken as coffee or tea. Sometimes shown on a saucer.",
  },
  {
    "web-scraper-order": "1666024578-715",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥛 Glass of Milk",
    "food-href": "https://emojipedia.org/glass-of-milk/",
    emoji: "🥛",
    emojiName: "🥛 Glass of Milk",
    description:
      "A tall glass of white milk, as from a cow but also other mammals, nuts, or plants. Most platforms depict a glass filled near to the brim, but some show a glass half-full—or half-empty.",
  },
  {
    "web-scraper-order": "1666024581-716",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍼 Baby Bottle",
    "food-href": "https://emojipedia.org/baby-bottle/",
    emoji: "🍼",
    emojiName: "🍼 Baby Bottle",
    description:
      "A bottle of milk or formula, as or fed to a baby, with a bluish cap and rubber nipple or teat. Positioned upright or at a 45° angle, and filled to various levels, sometimes showing fill lines. Often used for newborns and childrearing. See also Breast-Feeding.",
  },
  {
    "web-scraper-order": "1666024583-717",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍯 Honey Pot",
    "food-href": "https://emojipedia.org/honey-pot/",
    emoji: "🍯",
    emojiName: "🍯 Honey Pot",
    description:
      "A golden-yellow pot of honey, as made by bees and desired by bears. Shown with the sweet substance oozing down its sides, often with a honey dipper inside the small vessel.",
  },
  {
    "web-scraper-order": "1666024585-718",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍮 Custard",
    "food-href": "https://emojipedia.org/custard/",
    emoji: "🍮",
    emojiName: "🍮 Custard",
    description:
      "A golden-yellow custard dessert, as a crème caramel or flan, topped with a layer of caramel. Shown on a plate, molded in a ramekin-shape and often in a pool of caramel sauce.",
  },
  {
    "web-scraper-order": "1666024588-719",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍭 Lollipop",
    "food-href": "https://emojipedia.org/lollipop/",
    emoji: "🍭",
    emojiName: "🍭 Lollipop",
    description:
      "A colorful lollipop made of swirled hard candy attached to a stick. Colors vary by platform, though most designs show rainbow colors or pinks and reds.",
  },
  {
    "web-scraper-order": "1666024590-720",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍬 Candy",
    "food-href": "https://emojipedia.org/candy/",
    emoji: "🍬",
    emojiName: "🍬 Candy",
    description:
      "A small piece of candy wrapped in plastic or wax paper with twists on its ends. Shape and color vary widely by platform. Facebook’s design used to resemble a classic unwrapped red-and-white peppermint. May also be called sweets or lollies.",
  },
  {
    "web-scraper-order": "1666024593-721",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍫 Chocolate Bar",
    "food-href": "https://emojipedia.org/chocolate-bar/",
    emoji: "🍫",
    emojiName: "🍫 Chocolate Bar",
    description:
      "A block of dark chocolate, usually shown in a red foil wrapper peeled back to show squares of the candy. WhatsApp displays the wrapper in purple, a color commonly associated with Cadbury chocolate.",
  },
  {
    "web-scraper-order": "1666024595-722",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥧 Pie",
    "food-href": "https://emojipedia.org/pie/",
    emoji: "🥧",
    emojiName: "🥧 Pie",
    description:
      "A baked dish with a pastry crust, filled with sweet or savory ingredients. Appearance widely varies by platform.",
  },
  {
    "web-scraper-order": "1666024597-723",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧁 Cupcake",
    "food-href": "https://emojipedia.org/cupcake/",
    emoji: "🧁",
    emojiName: "🧁 Cupcake",
    description:
      "An individual cupcake in a liner topped with a swirl of frosting and sprinkles. The style of cupcake widely varies across platforms. The cake may be sponge or chocolate, the frosting pink or white, and the sprinkles rainbow or red.",
  },
  {
    "web-scraper-order": "1666024600-724",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍰 Shortcake",
    "food-href": "https://emojipedia.org/shortcake/",
    emoji: "🍰",
    emojiName: "🍰 Shortcake",
    description:
      "A slice of strawberry shortcake, layered with whipped cream and topped with a whole strawberry. Like the Birthday Cake, may be used to represent birthday celebrations or cake in general.",
  },
  {
    "web-scraper-order": "1666024604-725",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🎂 Birthday Cake",
    "food-href": "https://emojipedia.org/birthday-cake/",
    emoji: "🎂",
    emojiName: "🎂 Birthday Cake",
    description:
      "A frosted cake with lit candles, as presented for a birthday celebration. The style of cake widely varies across platforms. With white frosting and strawberries, Apple and Google’s designs suggest a Japanese Christmas cake. Other vendors depict a chocolate, pink, and/or sponge cake.",
  },
  {
    "web-scraper-order": "1666024607-726",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍪 Cookie",
    "food-href": "https://emojipedia.org/cookie/",
    emoji: "🍪",
    emojiName: "🍪 Cookie",
    description:
      "A golden-brown chocolate chip cookie or biscuit. Used to represent cookies or biscuits in general.",
  },
  {
    "web-scraper-order": "1666024609-727",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍩 Doughnut",
    "food-href": "https://emojipedia.org/doughnut/",
    emoji: "🍩",
    emojiName: "🍩 Doughnut",
    description:
      "A chocolate-glazed donut (or doughnut) with rainbow sprinkles. WhatsApp features a pink glaze associated with The Simpsons. May resemble the Bagel at small sizes.",
  },
  {
    "web-scraper-order": "1666024611-728",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍨 Ice Cream",
    "food-href": "https://emojipedia.org/ice-cream/",
    emoji: "🍨",
    emojiName: "🍨 Ice Cream",
    description:
      "One or more scoops of ice cream in a dessert bowl, variously topped with sprinkles, wafer rolls, or cherry and syrup. Flavors vary from vanilla, chocolate, and/or strawberry across platforms.",
  },
  {
    "web-scraper-order": "1666024614-729",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍧 Shaved Ice",
    "food-href": "https://emojipedia.org/shaved-ice/",
    emoji: "🍧",
    emojiName: "🍧 Shaved Ice",
    description:
      "A mound of shaved ice (snow cone) served in a dessert bowl with a short spoon, flavored with a cherry-red syrup on many platforms. Associated with Hawaiian shave ice or Japanese kakigori.",
  },
  {
    "web-scraper-order": "1666024617-730",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍦 Soft Ice Cream",
    "food-href": "https://emojipedia.org/soft-ice-cream/",
    emoji: "🍦",
    emojiName: "🍦 Soft Ice Cream",
    description:
      "A swirl of soft-serve ice cream atop a wafer-style cone, white or cream-colored, as vanilla, on most platforms. Facebook’s design suggests strawberry. May be used more generally for ice cream, frozen yogurt, and frozen treats.",
  },
  {
    "web-scraper-order": "1666024620-731",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🦪 Oyster",
    "food-href": "https://emojipedia.org/oyster/",
    emoji: "🦪",
    emojiName: "🦪 Oyster",
    description:
      "Half of an opened oyster shell with gray, pink, or orange flesh inside. Many platforms also include a pearl in the shell.",
  },
  {
    "web-scraper-order": "1666024623-732",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥡 Takeout Box",
    "food-href": "https://emojipedia.org/takeout-box/",
    emoji: "🥡",
    emojiName: "🥡 Takeout Box",
    description:
      "A tall, folded, paper carton, usually white, as used for takeout/takeaway food at Western Chinese restaurants. Most platforms depict chopsticks inside its open lid, labeled with a red, multi-tiered, traditional Chinese building. Also called an oyster pail.",
  },
  {
    "web-scraper-order": "1666024626-733",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥠 Fortune Cookie",
    "food-href": "https://emojipedia.org/fortune-cookie/",
    emoji: "🥠",
    emojiName: "🥠 Fortune Cookie",
    description:
      "A golden-brown, crescent-shaped, vanilla-flavored fortune cookie. Usually depicted with a strip of paper—on which a wise saying, lucky numbers, or Chinese vocabulary is written—peaking out of its hollow shell. Given at the end of meals at Chinese restaurants in the West.",
  },
  {
    "web-scraper-order": "1666024628-734",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥟 Dumpling",
    "food-href": "https://emojipedia.org/dumpling/",
    emoji: "🥟",
    emojiName: "🥟 Dumpling",
    description:
      "A dumpling of dough and filling, as folded and pinched closed for steaming or frying. Associated with cuisines around the world, including China (jiaozi), Japan (gyoza or dango), Poland (pierogi), and Spain and Latin America (empanada).",
  },
  {
    "web-scraper-order": "1666024631-735",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍡 Dango",
    "food-href": "https://emojipedia.org/dango/",
    emoji: "🍡",
    emojiName: "🍡 Dango",
    description:
      "A Japanese sweet dumpling made from rice flour and served on a skewer. Depicted as a botchan dango, comprising a pink, white or light yellow, and green ball, as colored by red beans, egg, and green tea. Resembles the Oden and featured in the Moon Viewing Ceremony, used in the Japanese festival to celebrate the full moon.",
  },
  {
    "web-scraper-order": "1666024633-736",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥮 Moon Cake",
    "food-href": "https://emojipedia.org/moon-cake/",
    emoji: "🥮",
    emojiName: "🥮 Moon Cake",
    description:
      "The round, golden-brown pastry of a Chinese mooncake, a traditional delicacy and lunar symbol of the Mid-Autumn Festival. Many platforms feature a design or character imprinted on the crust, and depict a slice cut out to show a brown paste with a duck egg yolk inside. Twitter displays the Chinese character for “fall/autumn” or “harvest” (秋) on top.",
  },
  {
    "web-scraper-order": "1666024636-737",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍥 Fish Cake with Swirl",
    "food-href": "https://emojipedia.org/fish-cake-with-swirl/",
    emoji: "🍥",
    emojiName: "🍥 Fish Cake with Swirl",
    description:
      "A slice of Japanese narutomaki, a ridged fishcake of processed whitefish with an iconic pink swirl, often served in ramen or oden. Thanks to its distinct swirl, may be used for flair.",
  },
  {
    "web-scraper-order": "1666024639-738",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍤 Fried Shrimp",
    "food-href": "https://emojipedia.org/fried-shrimp/",
    emoji: "🍤",
    emojiName: "🍤 Fried Shrimp",
    description:
      "A prawn or shrimp breaded and deep-fried golden-brown. Known as ebi furai in Japan but commonly called shrimp tempura and served in a bento box. Not to be confused with the Shrimp.",
  },
  {
    "web-scraper-order": "1666024642-739",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍣 Sushi",
    "food-href": "https://emojipedia.org/sushi/",
    emoji: "🍣",
    emojiName: "🍣 Sushi",
    description:
      "Japanese sushi, generally depicted as two pieces of raw pinkish-orange fish, as tuna or salmon, on white rice (nigiri). Some platforms show the cylindrical maki, a piece of seafood, vegetables, and white rice wrapped in seaweed (nori).",
  },
  {
    "web-scraper-order": "1666024645-740",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍢 Oden",
    "food-href": "https://emojipedia.org/oden/",
    emoji: "🍢",
    emojiName: "🍢 Oden",
    description:
      "A skewer of three bites of Japanese oden, a winter dish made with fishcakes, tofu, konnyaku, and a variety of other ingredients, including boiled eggs. Often served as a stew or skewered and dipped into soy sauce. Resembles the Dango and may be used for other skewered foods (e.g., shish kebab, roasting marshmallows) or spears.",
  },
  {
    "web-scraper-order": "1666024647-741",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍠 Roasted Sweet Potato",
    "food-href": "https://emojipedia.org/roasted-sweet-potato/",
    emoji: "🍠",
    emojiName: "🍠 Roasted Sweet Potato",
    description:
      "A sweet potato depicted with textured purple, orange, or brown skin and sliced in half to show its golden-brown flesh. Sometimes called a yam, though they are unrelated. Not to be confused with the Potato.",
  },
  {
    "web-scraper-order": "1666024649-742",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍝 Spaghetti",
    "food-href": "https://emojipedia.org/spaghetti/",
    emoji: "🍝",
    emojiName: "🍝 Spaghetti",
    description:
      "A plate of Italian spaghetti with tomato sauce, as a bolognese, with a fork twirling its long, thin noodles. Garnished with a green herb, as parsley, on some platforms.",
  },
  {
    "web-scraper-order": "1666024652-743",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍜 Steaming Bowl",
    "food-href": "https://emojipedia.org/steaming-bowl/",
    emoji: "🍜",
    emojiName: "🍜 Steaming Bowl",
    description:
      "A bowl of steaming-hot food. Depicted as Japanese ramen (noodles in broth) with chopsticks on most platforms, though it can represent a warm meal more generally.",
  },
  {
    "web-scraper-order": "1666024654-744",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍛 Curry Rice",
    "food-href": "https://emojipedia.org/curry-rice/",
    emoji: "🍛",
    emojiName: "🍛 Curry Rice",
    description:
      "A plate of orange-brown curry with vegetables or meat, served with a mound of white rice. May represent kare-raisu, or Japanese curry, though commonly associated with India and other Asian cuisines.",
  },
  {
    "web-scraper-order": "1666024657-745",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍚 Cooked Rice",
    "food-href": "https://emojipedia.org/cooked-rice/",
    emoji: "🍚",
    emojiName: "🍚 Cooked Rice",
    description:
      "A bowl of steamed white rice, a staple component of cuisine throughout Asia. Bowl color varies across platforms, though is often white.",
  },
  {
    "web-scraper-order": "1666024659-746",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍙 Rice Ball",
    "food-href": "https://emojipedia.org/rice-ball/",
    emoji: "🍙",
    emojiName: "🍙 Rice Ball",
    description:
      "A Japanese onigiri, a cone-shaped ball of white rice, a snack wrapped with a sheet of nori, or seaweed.",
  },
  {
    "web-scraper-order": "1666024661-747",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍘 Rice Cracker",
    "food-href": "https://emojipedia.org/rice-cracker/",
    emoji: "🍘",
    emojiName: "🍘 Rice Cracker",
    description:
      "A Japanese senbei, or rice cracker, wrapped with a sheet of nori, or seaweed, a snack commonly enjoyed with green tea.",
  },
  {
    "web-scraper-order": "1666024664-748",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍱 Bento Box",
    "food-href": "https://emojipedia.org/bento-box/",
    emoji: "🍱",
    emojiName: "🍱 Bento Box",
    description:
      "A Japanese bento, a lunch box divided into portions of rice, vegetables, and meat or seafood, such as sushi or fried shrimp.",
  },
  {
    "web-scraper-order": "1666024666-749",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥫 Canned Food",
    "food-href": "https://emojipedia.org/canned-food/",
    emoji: "🥫",
    emojiName: "🥫 Canned Food",
    description:
      "A can or tin of food, depicted as tomatoes or a generic green vegetable. May be also used to represent sauce or soup.",
  },
  {
    "web-scraper-order": "1666024669-750",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧂 Salt",
    "food-href": "https://emojipedia.org/salt/",
    emoji: "🧂",
    emojiName: "🧂 Salt",
    description:
      "A clear glass shaker of salt with a silver cap, as paired with pepper to season food when eating at a restaurant.",
  },
  {
    "web-scraper-order": "1666024671-751",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧈 Butter",
    "food-href": "https://emojipedia.org/butter/",
    emoji: "🧈",
    emojiName: "🧈 Butter",
    description:
      "A pale yellow stick of butter. Can be used to talk about cooking or eating. Might also be used in idioms or to reference something that is smooth.",
  },
  {
    "web-scraper-order": "1666024674-752",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍿 Popcorn",
    "food-href": "https://emojipedia.org/popcorn/",
    emoji: "🍿",
    emojiName: "🍿 Popcorn",
    description:
      "The buttery-white snack of popcorn brimming in a classic red-and-white-striped carton, as enjoyed at a movie theater.",
  },
  {
    "web-scraper-order": "1666024676-753",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥗 Green Salad",
    "food-href": "https://emojipedia.org/green-salad/",
    emoji: "🥗",
    emojiName: "🥗 Green Salad",
    description:
      "An undressed garden salad in a bowl with leafy-green lettuce and other ingredients such as tomato, red onion, and black olives. Commonly associated with healthy eating and living.",
  },
  {
    "web-scraper-order": "1666024678-754",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥣 Bowl with Spoon",
    "food-href": "https://emojipedia.org/bowl-with-spoon/",
    emoji: "🥣",
    emojiName: "🥣 Bowl with Spoon",
    description:
      "A bowl with a silver spoon inside, as used to eat cereal or soup. Bowl color varies across platforms, as do contents, though most are empty.",
  },
  {
    "web-scraper-order": "1666024681-755",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫕 Fondue",
    "food-href": "https://emojipedia.org/fondue/",
    emoji: "🫕",
    emojiName: "🫕 Fondue",
    description:
      "A red fondue pot. Most platforms show cheese fondue with fondue forks sticking out of the pot.",
  },
  {
    "web-scraper-order": "1666024683-756",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍲 Pot of Food",
    "food-href": "https://emojipedia.org/pot-of-food/",
    emoji: "🍲",
    emojiName: "🍲 Pot of Food",
    description:
      "A pot, as a casserole dish, filled with a warm and hearty beef or vegetable stew on most platforms. Generally used for eating and cooking (“a meal”), and commonly associated with soup or Japanese nabe.",
  },
  {
    "web-scraper-order": "1666024685-757",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥘 Shallow Pan of Food",
    "food-href": "https://emojipedia.org/shallow-pan-of-food/",
    emoji: "🥘",
    emojiName: "🥘 Shallow Pan of Food",
    description:
      "A flat, shallow, black pan with side handles, containing saffron-colored rice, vegetables, a leg of poultry, and/or shrimp and lemon slices. Commonly associated with paella, a traditional dish from Spain. May be used for eating, cooking, dining, and meals more generally.",
  },
  {
    "web-scraper-order": "1666024688-758",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍳 Cooking",
    "food-href": "https://emojipedia.org/cooking/",
    emoji: "🍳",
    emojiName: "🍳 Cooking",
    description:
      "An egg with yolk frying in a skillet, as prepared sunny-side up. Though associated with breakfast, the emoji represents the general action of cooking and related concepts.",
  },
  {
    "web-scraper-order": "1666024690-759",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥚 Egg",
    "food-href": "https://emojipedia.org/egg/",
    emoji: "🥚",
    emojiName: "🥚 Egg",
    description:
      "An egg, displayed as a chicken egg with a white or light brown shell. Commonly used at Easter time. See also: 🍳 Cooking.",
  },
  {
    "web-scraper-order": "1666024692-760",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧆 Falafel",
    "food-href": "https://emojipedia.org/falafel/",
    emoji: "🧆",
    emojiName: "🧆 Falafel",
    description:
      "Brown spheres depicting falafel, a food popular in Middle Eastern and North African cuisine, typically made of mashed chickpeas or fava beans. Most platforms include three or more falafel with one piece split open to reveal a green center. Can be used to talk about falafel and possibly other round brown food items like meatballs.",
  },
  {
    "web-scraper-order": "1666024695-761",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥙 Stuffed Flatbread",
    "food-href": "https://emojipedia.org/stuffed-flatbread/",
    emoji: "🥙",
    emojiName: "🥙 Stuffed Flatbread",
    description:
      "A flatbread, like pita, stuffed with lettuce, tomato, and/or meat. Resembles a doner kebab, falafel, shawarma, or gyro sandwich, popular in the Middle East and the Mediterranean. Some platforms have red onion and cucumber. Not to be confused with 🫓 Flatbread or 🌯 Burrito.",
  },
  {
    "web-scraper-order": "1666024698-762",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫔 Tamale",
    "food-href": "https://emojipedia.org/tamale/",
    emoji: "🫔",
    emojiName: "🫔 Tamale",
    description: "A single tamale wrapped in a corn husk.",
  },
  {
    "web-scraper-order": "1666024700-763",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌯 Burrito",
    "food-href": "https://emojipedia.org/burrito/",
    emoji: "🌯",
    emojiName: "🌯 Burrito",
    description:
      "A Mexican or Tex-Mex burrito, featuring a wrapped flour tortilla filled with such ingredients as beef, rice, beans, cheese, tomato, lettuce, and sour cream. Served in foil on several major platforms, suggesting a Mission burrito associated with San Francisco. Not to be confused with the Stuffed Flatbread.",
  },
  {
    "web-scraper-order": "1666024702-764",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌮 Taco",
    "food-href": "https://emojipedia.org/taco/",
    emoji: "🌮",
    emojiName: "🌮 Taco",
    description:
      "A Mexican or Tex-Mex taco on a hard or soft corn tortilla, filled with such ingredients as beef, lettuce, tomato, cheese, and onion. Apple’s design resembles a carne asada taco, with cilantro and white onion.",
  },
  {
    "web-scraper-order": "1666024705-765",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥪 Sandwich",
    "food-href": "https://emojipedia.org/sandwich/",
    emoji: "🥪",
    emojiName: "🥪 Sandwich",
    description:
      "A sandwich, as eaten at lunch, made with lettuce, tomato, and cheese on slices of white or wheat bread. Apple, Google, and WhatsApp add a deli meat that resembles ham.",
  },
  {
    "web-scraper-order": "1666024707-766",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌭 Hot Dog",
    "food-href": "https://emojipedia.org/hot-dog/",
    emoji: "🌭",
    emojiName: "🌭 Hot Dog",
    description:
      "The cooked sausage of a hot dog in a sliced bun and drizzled with yellow mustard, as eaten at a baseball game.",
  },
  {
    "web-scraper-order": "1666024709-767",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍕 Pizza",
    "food-href": "https://emojipedia.org/pizza/",
    emoji: "🍕",
    emojiName: "🍕 Pizza",
    description:
      "A slice of pepperoni pizza, previously also topped with black olives on Google. WhatsApp adds green pepper, Samsung white onion.",
  },
  {
    "web-scraper-order": "1666024712-768",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍟 French Fries",
    "food-href": "https://emojipedia.org/french-fries/",
    emoji: "🍟",
    emojiName: "🍟 French Fries",
    description:
      "Thin-cut, golden-brown French fries, served in a red carton, as at McDonald’s. Apple features Smiling Face With Smiling Eyes on its carton.",
  },
  {
    "web-scraper-order": "1666024714-769",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍔 Hamburger",
    "food-href": "https://emojipedia.org/hamburger/",
    emoji: "🍔",
    emojiName: "🍔 Hamburger",
    description:
      "A burger with a beef patty, usually depicted on a sesame bun with cheese, lettuce, and tomato—making it a cheeseburger, though officially called Hamburger by Unicode.",
  },
  {
    "web-scraper-order": "1666024717-770",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥓 Bacon",
    "food-href": "https://emojipedia.org/bacon/",
    emoji: "🥓",
    emojiName: "🥓 Bacon",
    description:
      "Strips of crispy, fatty, reddish-brown bacon, as fried for breakfast. Depicted as a pair on most platforms.",
  },
  {
    "web-scraper-order": "1666024719-771",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥩 Cut of Meat",
    "food-href": "https://emojipedia.org/cut-of-meat/",
    emoji: "🥩",
    emojiName: "🥩 Cut of Meat",
    description:
      "A cut of uncooked red meat, as a T-bone or rib-eye steak, with the light, white marbling of fat.",
  },
  {
    "web-scraper-order": "1666024721-772",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍗 Poultry Leg",
    "food-href": "https://emojipedia.org/poultry-leg/",
    emoji: "🍗",
    emojiName: "🍗 Poultry Leg",
    description:
      "A crispy brown leg (drumstick) of chicken, duck, turkey, or other poultry on the bone, as roasted at Thanksgiving or Christmas dinner or fried at fast-food restaurants.",
  },
  {
    "web-scraper-order": "1666024724-773",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍖 Meat on Bone",
    "food-href": "https://emojipedia.org/meat-on-bone/",
    emoji: "🍖",
    emojiName: "🍖 Meat on Bone",
    description:
      "A hunk of unspecified meat on a white bone, as associated with cartoon cavepersons or food in anime and manga (Japanese ano niku, “that meat”).",
  },
  {
    "web-scraper-order": "1666024726-774",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧀 Cheese Wedge",
    "food-href": "https://emojipedia.org/cheese-wedge/",
    emoji: "🧀",
    emojiName: "🧀 Cheese Wedge",
    description:
      "A wedge of yellow-orange cheese with holes, like a Swiss, but used for the food in general. May be used for various cheese-related slang expressions (e.g., “cheesy,” “say cheese,” “big cheese”).",
  },
  {
    "web-scraper-order": "1666024729-775",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧇 Waffle",
    "food-href": "https://emojipedia.org/waffle/",
    emoji: "🧇",
    emojiName: "🧇 Waffle",
    description:
      "A round or square Belgian waffle, baked to a golden brown. Most platforms depict this emoji topped with a pad of butter, and some include gooey syrup running down the sides.",
  },
  {
    "web-scraper-order": "1666024731-776",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥞 Pancakes",
    "food-href": "https://emojipedia.org/pancakes/",
    emoji: "🥞",
    emojiName: "🥞 Pancakes",
    description:
      "A stack of breakfast pancakes, topped with a pad of butter and maple syrup oozing down its golden-brown sides, onto a plate on some platforms.",
  },
  {
    "web-scraper-order": "1666024734-777",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥯 Bagel",
    "food-href": "https://emojipedia.org/bagel/",
    emoji: "🥯",
    emojiName: "🥯 Bagel",
    description:
      "The brown bread of a bagel, shown sliced in two halves. Some platforms depict seeds, as sesame or poppy, and a schmear of cream cheese, with the bagel assembled as a sandwich. May resemble the Doughnut at small sizes.",
  },
  {
    "web-scraper-order": "1666024736-778",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥨 Pretzel",
    "food-href": "https://emojipedia.org/pretzel/",
    emoji: "🥨",
    emojiName: "🥨 Pretzel",
    description:
      "The heart-shaped twist of a hard or soft golden-brown pretzel, seasoned with grains of salt. A snack commonly associated with Germany.",
  },
  {
    "web-scraper-order": "1666024739-779",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫓 Flatbread",
    "food-href": "https://emojipedia.org/flatbread/",
    emoji: "🫓",
    emojiName: "🫓 Flatbread",
    description:
      "A round piece of flatbread with grill marks. Used to represent any type of flatbread, soft or crunchy.",
  },
  {
    "web-scraper-order": "1666024741-780",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥖 Baguette Bread",
    "food-href": "https://emojipedia.org/baguette-bread/",
    emoji: "🥖",
    emojiName: "🥖 Baguette Bread",
    description:
      'The long, thin loaf of a baguette, with scoring on its golden-brown crust. A bread commonly associated with France. May also be used to denote financial success, as per the slang term "let\'s get this bread".',
  },
  {
    "web-scraper-order": "1666024743-781",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥐 Croissant",
    "food-href": "https://emojipedia.org/croissant/",
    emoji: "🥐",
    emojiName: "🥐 Croissant",
    description:
      "The flaky, golden-brown crescent of a croissant, a breakfast pastry associated with France and Austria.",
  },
  {
    "web-scraper-order": "1666024746-782",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍞 Bread",
    "food-href": "https://emojipedia.org/bread/",
    emoji: "🍞",
    emojiName: "🍞 Bread",
    description:
      'A loaf of white or wheat bread, as before it is sliced for toast or sandwiches. May also be used to denote financial success, as per the slang term "let\'s get this bread".',
  },
  {
    "web-scraper-order": "1666024749-783",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌰 Chestnut",
    "food-href": "https://emojipedia.org/chestnut/",
    emoji: "🌰",
    emojiName: "🌰 Chestnut",
    description:
      "The reddish-brown, acorn-shaped chestnut, tapering to a sharp tip from its light brown base on most platforms. A popular roasted snack associated with autumn and Christmas.",
  },
  {
    "web-scraper-order": "1666024751-784",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫘 Beans",
    "food-href": "https://emojipedia.org/beans/",
    emoji: "🫘",
    emojiName: "🫘 Beans",
    description: "Beans, as used in cuisines around the world.",
  },
  {
    "web-scraper-order": "1666024754-785",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥜 Peanuts",
    "food-href": "https://emojipedia.org/peanuts/",
    emoji: "🥜",
    emojiName: "🥜 Peanuts",
    description:
      "The pod of the peanut, shown in its rounded, grooved, light-brown shell. Apple depicts a pair.",
  },
  {
    "web-scraper-order": "1666024756-786",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍄 Mushroom",
    "food-href": "https://emojipedia.org/mushroom/",
    emoji: "🍄",
    emojiName: "🍄 Mushroom",
    description:
      "The edible fungus of the mushroom, depicted as a toadstool with a white-spotted red cap and stem.",
  },
  {
    "web-scraper-order": "1666024759-787",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧅 Onion",
    "food-href": "https://emojipedia.org/onion/",
    emoji: "🧅",
    emojiName: "🧅 Onion",
    description:
      "A round yellow onion. Can be used to talk about cooking, eating, or crying. Sometimes used in metaphors about layers. Might also be used in computing contexts in reference to onion routing.",
  },
  {
    "web-scraper-order": "1666024762-788",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧄 Garlic",
    "food-href": "https://emojipedia.org/garlic/",
    emoji: "🧄",
    emojiName: "🧄 Garlic",
    description:
      "A single white or light brown bulb of garlic. Can be used to talk about cooking, eating, or vampire protection.",
  },
  {
    "web-scraper-order": "1666024764-789",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥦 Broccoli",
    "food-href": "https://emojipedia.org/broccoli/",
    emoji: "🥦",
    emojiName: "🥦 Broccoli",
    description: "A rich green, tree-like head or floret of broccoli.",
  },
  {
    "web-scraper-order": "1666024767-790",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥬 Leafy Green",
    "food-href": "https://emojipedia.org/leafy-green/",
    emoji: "🥬",
    emojiName: "🥬 Leafy Green",
    description:
      "A head of a rich green leaf vegetable, usually shown with white stalks. May be used to represent a variety of greens, including romaine lettuce, chard, and Chinese cabbage like bok choy, as commonly cooked in Asian cuisines.",
  },
  {
    "web-scraper-order": "1666024769-791",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥒 Cucumber",
    "food-href": "https://emojipedia.org/cucumber/",
    emoji: "🥒",
    emojiName: "🥒 Cucumber",
    description:
      "A long, green cucumber with bumpy skin. Resembles its derived product, a pickle or gherkin, on many platforms, except on Apple and WhatsApp, which depict it with light-green, seed-y slices.",
  },
  {
    "web-scraper-order": "1666024771-792",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫑 Bell Pepper",
    "food-href": "https://emojipedia.org/bell-pepper/",
    emoji: "🫑",
    emojiName: "🫑 Bell Pepper",
    description:
      "A perfectly ripe red or green bell pepper. Can be used to talk about bell peppers or food in general.",
  },
  {
    "web-scraper-order": "1666024774-793",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌶️ Hot Pepper",
    "food-href": "https://emojipedia.org/hot-pepper/",
    emoji: "🌶️",
    emojiName: "🌶️ Hot Pepper",
    description:
      "A bright red Mexican chili pepper, slightly curled and with a green stem. May be used to represent something “hot and spicy,” figuratively or literally, as a dish on a restaurant menu.",
  },
  {
    "web-scraper-order": "1666024776-794",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌽 Ear of Corn",
    "food-href": "https://emojipedia.org/ear-of-corn/",
    emoji: "🌽",
    emojiName: "🌽 Ear of Corn",
    description:
      "An ear of corn, or maize, partially husked to show its buttery-yellow kernels.",
  },
  {
    "web-scraper-order": "1666024778-795",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥕 Carrot",
    "food-href": "https://emojipedia.org/carrot/",
    emoji: "🥕",
    emojiName: "🥕 Carrot",
    description:
      "A whole, bright orange carrot, topped with long green leaves, as if freshly plucked from the garden. Some platforms feature a longer, thinner carrot, others a shorter, more bulbous one.",
  },
  {
    "web-scraper-order": "1666024781-796",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥔 Potato",
    "food-href": "https://emojipedia.org/potato/",
    emoji: "🥔",
    emojiName: "🥔 Potato",
    description:
      "A whole potato—such as a russet, used for baking, mashing, or frying—shown with a few eyes on its golden-brown skin. Not to be confused with the roasted sweet potato.",
  },
  {
    "web-scraper-order": "1666024783-797",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍆 Eggplant",
    "food-href": "https://emojipedia.org/eggplant/",
    emoji: "🍆",
    emojiName: "🍆 Eggplant",
    description:
      "A long, bulbous, bright purple eggplant, or aubergine in British English, shown with a leafy stem. Considered lucky in Japan to dream of an eggplant the first night of the New Year.",
  },
  {
    "web-scraper-order": "1666024785-798",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥑 Avocado",
    "food-href": "https://emojipedia.org/avocado/",
    emoji: "🥑",
    emojiName: "🥑 Avocado",
    description:
      "A pear-shaped avocado, sliced in half to show its yellow-green flesh and large brown pit. Ready for toast, guacamole, or millennial jokes.",
  },
  {
    "web-scraper-order": "1666024788-799",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥥 Coconut",
    "food-href": "https://emojipedia.org/coconut/",
    emoji: "🥥",
    emojiName: "🥥 Coconut",
    description:
      "The hairy shell of a tropical coconut, cracked in a half to show its milky-white meat.",
  },
  {
    "web-scraper-order": "1666024790-800",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫒 Olive",
    "food-href": "https://emojipedia.org/olive/",
    emoji: "🫒",
    emojiName: "🫒 Olive",
    description:
      "One, two, or three green olives, either pitted or sprouting from a branch. Some platforms show a solitary pitted green olive stuffed with a piece of a pimento pepper.",
  },
  {
    "web-scraper-order": "1666024792-801",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍅 Tomato",
    "food-href": "https://emojipedia.org/tomato/",
    emoji: "🍅",
    emojiName: "🍅 Tomato",
    description:
      "A plump, red garden tomato topped with a leafy green stem. May resemble the red apple at small sizes.",
  },
  {
    "web-scraper-order": "1666024795-802",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥝 Kiwi Fruit",
    "food-href": "https://emojipedia.org/kiwi-fruit/",
    emoji: "🥝",
    emojiName: "🥝 Kiwi Fruit",
    description:
      "A kiwifruit, or Chinese gooseberry, with its fuzzy, brown skin sliced open to show its light-green flesh, white core, and black seeds.",
  },
  {
    "web-scraper-order": "1666024797-803",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫐 Blueberries",
    "food-href": "https://emojipedia.org/blueberries/",
    emoji: "🫐",
    emojiName: "🫐 Blueberries",
    description:
      "A few ripe blueberries clustered together. Most platforms show three blueberries, and some show small green leaves coming out from behind the blueberries.",
  },
  {
    "web-scraper-order": "1666024799-804",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍓 Strawberry",
    "food-href": "https://emojipedia.org/strawberry/",
    emoji: "🍓",
    emojiName: "🍓 Strawberry",
    description:
      "The fruit of a rich red strawberry dotted with seeds and crowned with green leaves. Google previously depicted the fruit in orange.",
  },
  {
    "web-scraper-order": "1666024802-805",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍒 Cherries",
    "food-href": "https://emojipedia.org/cherries/",
    emoji: "🍒",
    emojiName: "🍒 Cherries",
    description:
      "Two rich red cherries with a green leaf and joined at their long stems. May be used to refer to breasts on TikTok and other social media platforms.",
  },
  {
    "web-scraper-order": "1666024804-806",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍑 Peach",
    "food-href": "https://emojipedia.org/peach/",
    emoji: "🍑",
    emojiName: "🍑 Peach",
    description:
      "The fleshy, pinkish-orange fruit of the fuzzy peach, shown with green leaves and sometimes a stem.",
  },
  {
    "web-scraper-order": "1666024807-807",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍐 Pear",
    "food-href": "https://emojipedia.org/pear/",
    emoji: "🍐",
    emojiName: "🍐 Pear",
    description:
      "A light-green variety of a common pear, shown with a stem and sometimes green leaf.",
  },
  {
    "web-scraper-order": "1666024809-808",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍏 Green Apple",
    "food-href": "https://emojipedia.org/green-apple/",
    emoji: "🍏",
    emojiName: "🍏 Green Apple",
    description:
      "A common green apple, tarter counterpart to the Red Apple. Displayed with a stem and single, green leaf on major platforms.",
  },
  {
    "web-scraper-order": "1666024812-809",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍎 Red Apple",
    "food-href": "https://emojipedia.org/red-apple/",
    emoji: "🍎",
    emojiName: "🍎 Red Apple",
    description:
      "A classic red apple, shown with a stem and single, green leaf on major platforms. Commonly associated with doctors, teachers, and New York.",
  },
  {
    "web-scraper-order": "1666024814-810",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥭 Mango",
    "food-href": "https://emojipedia.org/mango/",
    emoji: "🥭",
    emojiName: "🥭 Mango",
    description:
      "The ripe fruit of a tropical mango. Variously depicted in shades of yellow, red, orange, and green with a single, green leaf and stem.",
  },
  {
    "web-scraper-order": "1666024816-811",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍍 Pineapple",
    "food-href": "https://emojipedia.org/pineapple/",
    emoji: "🍍",
    emojiName: "🍍 Pineapple",
    description:
      "The tropical fruit of a pineapple, shown in spiky, golden-brown skin and with a pointed, green crown. Positioned upright or at a 45° angle.",
  },
  {
    "web-scraper-order": "1666024819-812",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍌 Banana",
    "food-href": "https://emojipedia.org/banana/",
    emoji: "🍌",
    emojiName: "🍌 Banana",
    description:
      "A ripe banana, peeled and ready to eat on major platforms. Great snack for a child or monkey.",
  },
  {
    "web-scraper-order": "1666024821-813",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍋 Lemon",
    "food-href": "https://emojipedia.org/lemon/",
    emoji: "🍋",
    emojiName: "🍋 Lemon",
    description:
      "The sour, yellow-colored citrus fruit of the lemon, usually with a stem and green leaf or leaves.",
  },
  {
    "web-scraper-order": "1666024823-814",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍊 Tangerine",
    "food-href": "https://emojipedia.org/tangerine/",
    emoji: "🍊",
    emojiName: "🍊 Tangerine",
    description:
      "An orange-colored citrus fruit with a green leaf or leaves and stem. Officially depicting a tangerine, a type of mandarin (mikan in Japan). Often used as a garden-variety orange. Either way, a good source of vitamin C.",
  },
  {
    "web-scraper-order": "1666024825-815",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍉 Watermelon",
    "food-href": "https://emojipedia.org/watermelon/",
    emoji: "🍉",
    emojiName: "🍉 Watermelon",
    description:
      "A slice of watermelon, showing its rich pink flesh, black seeds, and green rind.",
  },
  {
    "web-scraper-order": "1666024828-816",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍈 Melon",
    "food-href": "https://emojipedia.org/melon/",
    emoji: "🍈",
    emojiName: "🍈 Melon",
    description:
      "A melon fruit in a light greenish-brown rind. Depicted as a cantaloupe by most platforms, but can resemble a honeydew at a distance.",
  },
  {
    "web-scraper-order": "1666024830-817",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍇 Grapes",
    "food-href": "https://emojipedia.org/grapes/",
    emoji: "🍇",
    emojiName: "🍇 Grapes",
    description:
      "A grape bunch, as cut from the vine and used to make wine. Depicted as red (purple-colored) grapes.",
  },
];

export default food;
